export default __webpack_public_path__ + "static/media/key-delete.2285f3e8.svg";